import { render, staticRenderFns } from "./produto.vue?vue&type=template&id=b2ceba58&"
import script from "./produto.vue?vue&type=script&lang=js&"
export * from "./produto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports